class BlacklistEmails {
  constructor() {
    this.id = null;
    this.idCliente = null;
    this.email = null;
  }
}

export default BlacklistEmails;